import { Box, Button, Icon, Text } from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { BackButtonProps } from './back-button.types'

export const BackButton = ({ url, onClick }: BackButtonProps) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const handleNavigate = () => {
    if (url) {
      navigate(url)
      return
    }

    navigate(-1)
  }
  return (
    <Box justifyContent="flex-start" alignItems="center" gap={1}>
      <Button
        variant="outlined"
        onClick={onClick ?? handleNavigate}
        padding={`${theme.spacing['1']}`}
      >
        <Icon name="arrow_left" size={16} color="grey_1" />
      </Button>
      <Text>Voltar</Text>
    </Box>
  )
}
